import { useEffect, useRef, useState } from 'react'
import { DateRangePicker } from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import useOnClickOutside from 'hooks/useOnClickOutside'
import { cx } from 'utils'

interface Props {
	onChange: (_range: any) => void
	position?: string
}

const MyDateRangePicker: React.FC<Props> = ({ onChange, position = 'left' }) => {
	const ref = useRef<any>(null)
	const [open, setOpen] = useState<boolean>(false)
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
		key: 'date',
	})

	useEffect(() => {
		onChange(dateRange)
	}, [dateRange, onChange])

	const handleChange = (range: Record<any, any>): void => {
		setDateRange(range.date)
		setOpen(false)
	}

	useOnClickOutside({ ref, onClickOutside: () => setOpen(false) })

	return (
		<div className="relative inline" ref={ref}>
			<button className="app-input" onClick={() => setOpen((prev) => !prev)}>
				{dateRange.startDate.toISOString().slice(0, 10)}
				{' ~ '}
				{dateRange.endDate.toISOString().slice(0, 10)}
			</button>
			<div
				className={cx(
					'absolute -bottom-1 z-50 translate-y-full border border-primary shadow-xl transition-opacity duration-300 ease-in-out',
					position === 'right' ? 'left-0' : 'right-0',
					open ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
				)}
			>
				<DateRangePicker ranges={[dateRange]} onChange={handleChange} />
			</div>
		</div>
	)
}

export default MyDateRangePicker
